import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";
import api from "@/lib/api";

const MESSAGES = {
  checking: "جارٍ التحقق من عملية الدفع...",
  paid: "تم تأكيد الدفع بنجاح",
  pending: "تم استلام طلب الدفع، سيظهر التأكيد خلال لحظات",
  failed: "لم تكتمل عملية الدفع",
  cancel: "تم إلغاء عملية الدفع",
};

const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

async function verifyMoyasar(kind, ref) {
  for (let i = 0; i < 4; i += 1) {
    try {
      const { data } = await api.post("/payments/moyasar/verify", { kind, ref_id: ref });
      if (data.status === "paid") return "paid";
    } catch (e) { return "failed"; }
    await sleep(2000);
  }
  return "failed";
}

export default function PaymentReturn() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const kind = params.get("kind");
  const ref = params.get("ref");
  const provider = params.get("provider") || "tamara";
  const result = params.get("result");
  const [state, setState] = useState(result === "cancel" ? "cancel" : "checking");

  useEffect(() => {
    let alive = true;
    const dest = kind === "tow" ? `/app/tow/${ref}` : `/app/request/${ref}`;
    const run = async () => {
      let s = state;
      if (s === "checking") {
        if (provider === "moyasar") s = await verifyMoyasar(kind, ref);
        else s = result === "failure" ? "failed" : "pending";
      }
      if (!alive) return;
      setState(s);
      await sleep(2200);
      if (alive) navigate(dest, { replace: true });
    };
    run();
    return () => { alive = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [kind, ref, provider, result]);

  const ok = state === "paid" || state === "pending";
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background gap-4 px-6 text-center" dir="rtl" data-testid="payment-return">
      {state === "checking" ? <Loader2 className="w-14 h-14 animate-spin text-accent" />
        : ok ? <CheckCircle2 className="w-14 h-14 text-emerald-500" /> : <XCircle className="w-14 h-14 text-destructive" />}
      <h1 className="font-heading text-2xl font-extrabold" data-testid="payment-return-status">{MESSAGES[state]}</h1>
      {state !== "checking" && (
        <p className="text-muted-foreground flex items-center gap-2 text-sm">
          <Loader2 className="w-4 h-4 animate-spin" /> جارٍ تحويلك إلى تفاصيل الطلب...
        </p>
      )}
    </div>
  );
}
